import { type DefaultRootState } from 'react-redux';

const spaceTitleById = (id?: number) => (state: DefaultRootState) => state.spaceList.data?.[id || 0]?.title;

export default spaceTitleById;
